<template>
    <feature :feature-key="featureKey">
        <tooltip
            v-if="withTooltip"
            target-class="cursor-default w-fit h-fit flex justify-center items-center gap-3 text-body-sm text-secondary border border-secondary rounded-sm px-4 py-2"
            :content="tooltipContent ?? $t('general.new_feature.tooltip')"
            position="top"
        >
            <svg-icon type="new-feature" class="w-16 h-16" />
            <slot name="title"/>
            {{ !$slots.title ? $t('general.new_feature.title') : null }}
        </tooltip>
        <div v-else class="cursor-default w-fit h-fit flex justify-center items-center gap-3 text-body-sm text-secondary border border-secondary rounded-sm px-4 py-2">
            <svg-icon type="new-feature" class="w-16 h-16" />
            <slot name="title"/>
            {{ !$slots.title ? $t('general.new_feature.title') : null }}
        </div>
    </feature>
</template>
<script>
import SvgIcon from "./SvgIcon";
import Tooltip from "../navigation/Tooltip.vue";
import Feature from "../Feature.vue";
export default {
    name: "NewFeatureTag",
    components: {
        Feature,
        Tooltip,
        'svg-icon': SvgIcon,
    },
    props: {
        withTooltip: {
            type: Boolean,
            default: true,
        },
        tooltipContent: String,
        featureKey: {
            type: String,
            required: true,
        },
    }
}
</script>
<style scoped>

</style>